<div class="main-page-wrapper p0 overflow-hidden" (contextmenu)="disableRightClick($event)">
  <div class="user-data-page clearfix d-lg-flex">
    <div class="illustration-wrapper d-flex align-items-center justify-content-between flex-column">
      <div class="illustration-holder">
        <img src="assets/images/assets/ils_11.svg" alt="" class="illustration">
      </div>
    </div> 

    <div class="form-wrapper">
      <form ngNativeValidate #subForm="ngForm" (submit)="getEncryptionKey(subForm.value)" class="user-data-form mt-80 md-mt-40">
        <div class="row">
          <div class="col-12">
            <div class="input-group-meta mb-80 sm-mb-70">
              <label>Mobile*</label>
              <input required ngModel #mobile_no="ngModel" name="mobile_no" pattern="[5-9]{1}[0-9]{9}" type="text">
              <div class="error_text"  *ngIf="mobile_no.touched">
                <p *ngIf="mobile_no.errors?.['required']">Mobile No is required.</p>
                <p *ngIf="mobile_no.errors?.['pattern']">Please Enter Valid Mobile Number.</p>
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="input-group-meta mb-15">
              <label>Password*</label>
              <input required type="password" ngModel name="password"
             placeholder="Enter Password" class="pass_log_id"
             (copy)="disableAction($event)"
          (paste)="disableAction($event)"
          (cut)="disableAction($event)">
              <!-- <span (click)="handleHidePassword()" class="placeholder_icon">
                <span class="passVicon"
                [ngClass]="hidePassword ? 'hide-pass' : ''">
                  <img src="assets/images/icon/view.svg" alt="">
                </span>
              </span> -->
            </div>
          </div>
          <div class="col-12">
            <div class="agreement-checkbox d-flex justify-content-between align-items-center">
              <a [routerLink]="['/forgot-password']">Forgot Password?</a>
            </div>
          </div>
          <div class="col-12 mb-30">
            <re-captcha 
              [siteKey]="env.recaptcha_site_key"
              (resolved)="resolvedRecaptcha($event)" 
              #captchaRef>
            </re-captcha>
          </div>
          <div class="col-6">
            <button type="submit" class="theme-btn-one mt-50 mb-50" >Login</button>
          </div>
          <div class="col-6">
            <button type="button" [routerLink]="['/register']" class="theme-btn-one mt-50 mb-50">Create New User</button>
          </div>
          
        </div>
      </form>
    </div> <!-- /.form-wrapper -->
  </div>
</div>
